<template>
  <div class="agree">
    <el-dialog
      title="协议"
      :visible.sync="dialogVisible"
      width="70%">
    <!-- <p class="MsoNormal" align="justify" style="margin-left:0.0000pt;text-align:justify;">
      PSBC[2022]ZH03029
    </p> -->
    <p class="MsoNormal" align="right" style="margin-left:0.0000pt;text-align:right;">
      &nbsp;
    </p>
    <p class="MsoNormal" align="center" style="font-size: 18px;text-indent:0.0000pt;text-align:center;font-family: '方正小标宋简体', sans-serif;">
      中国邮政储蓄银行借记卡快捷支付业务线上服务协议
    </p>
    <p class="MsoNormal">
      &nbsp;
    </p>
    <p class="MsoNormal" align="justify" style="text-align:justify;">
      <b>尊敬的客户：为了维护您的权益，请</b><b>您在同意接受本协议之前</b><b>，仔细阅读本</b><b>协议</b><b>各条款</b><b>，</b><b>特别是</b><b>黑体字加粗的内容</b><b>。</b><b>如您不同意本协议条款或无法准确理解本协议的相关内容</b><b>，请勿进行下一步操作，请拨打邮储银行客服</b><b>及投诉</b><b><span>热线：</span><span>95580</span></b><b>，以便我们向您解释咨询</b><b>。</b><b>您通过</b><b>点击签约页面确认</b><b>的方式选择</b><b>签订本服务协议，</b><b>即表示您确认接受本协议的全部内容，同意</b><b>开通快捷支付业务功能并承担由此产生的</b><b>相关法律责任</b><b><span>。</span> </b><b></b> 
    </p>
    <p class="MsoNormal" align="justify" style="margin-left:20.7000pt;text-indent:0.0000pt;text-align:justify;">
      一、<b>业务定义</b><b></b> 
    </p>
    <p class="MsoNormal" align="justify" style="text-indent:21.0000pt;text-align:justify;">
      中国邮政储蓄银行借记卡快捷支付业务是中国邮政储蓄银行（以下简称“邮储银行”）和<b>现代金融控股（成都）有限公司</b>（以下简称“支付合作机构”）联合为邮储银行借记卡个人客户（以下简称“您”）提供的，将邮储银行卡与支付账户签约绑定后，邮储银行即可根据支付合作机构发送的指令，从您指定的借记卡账户中划扣相应款项的支付服务业务。凡是持有邮储银行借记卡且同时为支付合作机构<span>用户的客户，均可申请该业务。</span>
    </p>
    <p class="MsoNormal" align="justify" style="margin-left:20.7000pt;text-indent:0.0000pt;text-align:justify;">
      二、<b>权利和义务</b><b></b> 
    </p>
    <p class="MsoNormal" align="justify" style="text-indent:21.1000pt;text-align:justify;">
      1.<b>您</b><b>同意邮储银行以</b><b>支付合作机构</b><b>传送至邮储银行的</b><b>姓名</b><b>、</b><b>银行</b><b>卡号、</b><b><span>证件类型及</span></b><b><span>证</span></b><b><span>件</span></b><b><span>号</span></b><b><span>码</span></b><b>、手机号码和手机短信验证码作为确认客户身份、为客户开通</b><b>支付合作机构</b><b>快捷支付业务的唯一依据。</b>您需确保您所提供的姓名、银行卡号、证件类型及证件号码、手机号码等信息真实有效。<b></b>
    </p>
    <p class="MsoNormal" align="justify" style="text-indent:21.0000pt;text-align:justify;">
      2.为了开通快捷支付业务或交易风险短信验证所必需，您理解并同意邮储银行将<b>姓名</b><b>、</b><b>银行</b><b>卡号、</b><b>证件类型及</b><b>证</b><b>件</b><b>号</b><b>码</b><b>、手机号码</b>通过加密方式发送至支付合作机构（联系方式请见支付合作机构官方网站公布）。<b>授权页面会展示具体授权信息、第三方名称、处理目的、处理方式等，请您具体关注授权页面。</b><b></b>
    </p>
    <p class="MsoNormal" align="justify" style="text-indent:21.1000pt;text-align:justify;">
      3.<b>您应保证业务开通时在邮储银行预留的手机号码为本人手机号码，否则由此导致的损失，邮储银行不承担赔偿责任。</b><b>您</b><b>须妥善保管本人邮储银行借记卡信息、身份信息、手机短信验证码、安全认证工具等</b><b>个人</b><b>信息，不得将</b><b>个人</b><b>信息向他人透露。因</b><b>您</b><b>的</b><b>个人信息、银行卡片信息、手机等保管不善产生的风险及损失由</b><b>您</b><b>本人承担。</b>
    </p>
    <p class="MsoNormal" align="justify" style="text-indent:21.1000pt;text-align:justify;">
      4.<b>您</b><b>同意并授权邮储银行在校验</b><b>您的</b><b>手机短信验证码通过后，按照</b><b>支付合作机构</b><b>的交易指令从</b><b>您</b><b>指定的借记卡账户中支付相应款项，</b><b>您</b><b>对此</b><b>交易验证方式及交易规则</b><b>无</b><b>异议。</b>
    </p>
    <p class="MsoNormal" align="justify" style="text-indent:21.1000pt;text-align:justify;">
      5.为确保您的网上支付资金安全，邮储银行有权设置或修改支付限额。您在支付时需同时受邮储银行和支付合作机构设置的支付限额的约束，<b>如</b><b>您</b><b>实际支付金额大于规定的支付限额，邮储银行将拒绝执行该笔交易。</b>如您需查看支付限额，可在邮储银行相关渠道或者支付合作机构端进行查询。<b></b>
    </p>
    <p class="MsoNormal" align="justify" style="text-indent:21.0000pt;text-align:justify;">
      6.您承诺在指定的银行付款账户中保留足够的余额，并保持账户处于正常状态。<b>因付款账户余额不足、账户被冻结、销户等非邮储银行过错而导致的</b><b>无法成功支付费用及所造成的纠纷和违约责任、损失等，您在符合法律法规要求的范围内自行承担法律后果。</b>
    </p>
    <p class="MsoNormal" align="justify" style="text-indent:21.1000pt;text-align:justify;">
      7.您<b>不得利用邮储银行</b><b>支付合作机构</b><b>快捷支付业务进行套现、虚假交易、洗钱</b><b>、</b><b>非法融资</b><b>等行为，且有义务配合邮储银行进行相关调查，如</b><b>在快捷支付业务签约期间出现监管机关规定的或邮储银行认定的风险特征时</b><b>，邮储银行有权采取以下一种或多种措施：</b><span>（</span><span>1）暂停或终止提供本协议项下</span>支付合作机构<span>快捷支付业务；（</span><span>2）终止本协议；（3）取消</span>您的用卡资格。根据相关法律约定，您需对提供给邮储银行资料的真实性、有效性及取得资料的合法性负责，<b>并同意邮储银行将上述资料、信息用于洗钱风险管理。</b>
    </p>
    <p class="MsoNormal" align="justify" style="text-indent:21.1000pt;text-align:justify;">
      8.因<b>非邮储银行原因以及邮储银行无法控制和不可预测的原因造成的</b><b>电力中断、电脑、网络等通讯故障，或不可抗力等因素</b>导致支付合作机构快捷支付业务中断或者处于不稳定状态，邮储银行已尽力采取补救措施但仍未能避免损失的情况下，不承担相关责任。
    </p>
    <p class="MsoBodyText" style="text-indent:21.0000pt;">
      9.为了及时、准确地完成签约及快捷支付，并满足反洗钱等监管要求，<b>您理解并同意邮储银行需要记录您使用本服务的用户实名认证信息、银行卡信息、交易信息</b><b>，并将采取符合监管要求的保护措施，保障您的信息安全和合法权益</b><b>。</b>在您使用本服务期间或本服务终止后，<b>您理解并同意邮储银行在相关法律法规或监管要求的必要期限内留存您在开通及使用本服务过程中产生的相关数据。</b>
    </p>
    <p class="MsoNormal" align="justify" style="text-indent:21.1000pt;text-align:justify;">
      <b>三、差错和争议的解决</b><b></b>
    </p>
    <p class="MsoBodyText" style="text-indent:21.1000pt;">
      <b>1.邮储银行不对支付合作机构提交的扣款交易指令进行实质性审核，不负责审核支付合作机构提交扣款指令的真实性、合法性、准确性。如您对邮储银行依据支付合作机构指令进行扣款的行为存在异议，应与支付合作机构协商解决。</b>
    </p>
    <p class="MsoNormal" align="justify" style="text-indent:21.1000pt;text-align:justify;">
      2.<b>邮储银行</b><b>仅为您提供安全可靠的</b><b>支付结算服务。</b><b>您</b><b>因通过</b><b>支付合作机构</b><b>或</b><b>支付合作机构</b><b>商户购买商品而产生的一切关于商品或服务质量、商品交付的争议，由</b><b>您</b><b><span>与商品</span><span>/服务的实际销售商以及</span></b><b>支付合作机构</b><b>自行协商解决。</b>
    </p>
    <p class="MsoNormal" align="justify" style="text-indent:21.1000pt;text-align:justify;">
      3.本协议自您在快捷支付业务开通页面点击确认后立即生效。本协议的生效、履行及解释均适用中国法律。<b>因本协议产生任何争议，双方应友好协商解决；协商不成</b><b>的</b><b>，任何一方有权向被告住所地</b><b>有</b><b>管辖权的人民法院提起诉讼。因本协议进入调解、诉讼、仲裁、执行等程序涉及的各类文书可通过电子邮件、传真、微信等方式送达至您，送达信息到达电子送达地址所在系统时，即为完成有效送达。</b><b></b>
    </p>
    <p class="MsoBodyText" style="text-indent:21.1000pt;">
      <b>四、协议的效力</b><b></b>
    </p>
    <p class="MsoNormal" align="justify" style="text-indent:21.1000pt;text-align:justify;">
      <b>1.</b><b>您理解并同意，针对本协议一般要素（包括不限于法律规定、监管要求、业务发展等），我行有权变更</b><b>或</b><b><span>暂停本协议条款，但必须于执行前通过邮储银行网站（</span><span>http://www.psbc.com/cn/）或营业网点、短信等方式进行公告。请您及时认真查阅本协议及变更后的内容；对于重要要素（包括不限于个人信息授权内容变更、业务形式变更等），我行将</span></b><b>在获得</b><b>您</b><b>的</b><b>授权后</b><b>履行协议条款</b><b>。</b>对相关条款如有异议，您可以在履行本协议项下应尽义务后解除本协议，并通过邮储银行手机银行或者<b>支付合作机构</b>端解除快捷支付签约关系。<b></b>
    </p>
    <p class="MsoNormal" style="text-indent:21.0000pt;">
      2.如邮储银行与<b>支付合作机构</b>业务合作终止，自终止之日起本协议自动失效。如您需注销快捷支付业务，可以通过<b>支付合作机构</b>端发起注销申请，业务注销自邮储银行同意并在银行系统中设置成功后生效。&nbsp;<b></b>
    </p>
    <p class="MsoBodyText" style="text-indent:21.0000pt;">
      3.如因签约卡注销、补（换）卡等任何原因导致卡号变更或失效，视同原快捷支付服务签约关系解除，需重新签约。
    </p>
    <p class="MsoBodyText" style="text-indent:21.1000pt;">
      <b>五、</b><b>用户信息授权</b><b></b> 
    </p>
    <p class="MsoBodyText" style="text-indent:21.1000pt;">
      <b>您知悉上述您授权的银行卡号、证件号码等</b><b>属于您的敏感</b><b>个人</b><b>信息，</b><b>一旦泄露可能对您的权益产生</b><b>不利</b><b>影响或</b><b>资金</b><b>风险</b><b>。</b><b>我行会在法律允许和业务范围内处理您的敏感个人信息，并要求支付合作机构依法使用您所授权的信息，并对您的信息保密</b><b>。</b>您可通过邮储银行营业网点查询、复制、更正、补充、删除等上述您授权的个人信息，及通过解约方式撤回上述授权。当您撤回同意邮储银行处理有关您本人信息后，邮储银行将不再处理您相应的个人信息，但您理解，您撤回同意的决定不会影响撤回前基于您的同意已开展的个人信息的处理。如果您拟撤回同意的信息属于邮储银行提供服务的必要信息，您应在邮储银行提供相关服务前或相关服务终止后再进行撤回。
    </p>
    <p class="MsoBodyText" style="text-indent:0.0000pt;">
      &nbsp;
    </p>
    <p class="MsoNormal" style="text-indent:0.0000pt;">
      &nbsp;
    </p>
    <p class="MsoNormal" style="text-indent:24.1pt;">
      <b>客户</b><b>声明：</b><b>邮储银行</b><b>已依法向我方提示了本</b><b>协议</b><b>相关条款（特别是黑体字</b><b>加粗内容</b><b>），应我方要求对相关条款的概念、内容及法律效果作了说明，我方已经知悉并理解上述条款。</b><b></b>
    </p>
    <p class="MsoNormal">
      &nbsp;
    </p>
    <p class="MsoNormal">
      &nbsp;
    </p>
    <p>
      <br />
    </p>
    <p>
      <br />
    </p>
      <!--  </span>一、我们如何收集和使用您的个人信息<span><br>
      </span>二、我们如何存储和保护您的个人信息<span><br>
      </span>三、我们如何对外提供您的个人信息<span><br>
      </span>四、您如何管理自己的个人信息<span><br>
      </span>五、<span>Cookie</span>和同类技术的使用<span><br>
      </span>六、未成年人使用条款<span><br>
      </span>七、第三方提供服务的免责声明<span><br>
      </span>八、本政策的适用与更新<span><br>

        <b style="mso-bidi-font-weight:normal" /></span></p>

      <p><b style="mso-bidi-font-weight:normal">定义与说明<span /></b></p>

      <p><span><br>
      </span>现代金融控股（成都）有限公司（以下简称<span>“</span>我们<span>”</span>或<span>“</span>现代支付<span>”</span>）一直重视并采取措施保护用户（以下简称<span>“</span>您<span>”</span>）的个人信息。在您使用我们提供的<span>APP</span>时，我们将根据本《小金管家<span>APP</span>隐私政策》（以下简称<span>“</span>本政策<span>”</span>）以及其他相关法律文本中的有关规定收集、使用、存储及对外提供您的个人信息。此外，我们将通过本政策，说明您如何访问、更新、管理您的个人信息以及行使您的相关权利。<span><br>
        <br>
      </span>我们将尽力采用通俗易懂的文字表述向您进行说明和告知，并就本政策中可能与您的合法利益存在重大关系的条款，采用字体加粗的方式以提请您的注意。我们强烈建议您在注册账号、使用我们的服务前，仔细阅读并完全理解本政策中的全部内容，并自主进行适当的选择。如果您不同意本政策的内容，我们将无法为您提供完整的产品和服务，同时您也需要立即停止使用小金管家<span>APP</span>产品及相关服务。如您开始使用我们的产品或服务，则视为您已经充分、完全地阅读并理解了本政策中的全部内容，并且同意我们按照本政策的规定收集、使用、存储及对外提供您的个人信息。<span><br>
        <br>
      </span>本政策适用于在中华人民共和国境内<span>&nbsp;(</span>港、澳、台地区除外<span>)&nbsp;</span>收集、使用、存储及对外提供您的个人信息的行为。如您对本政策内容有任何疑问、意见或建议，您可通过【拨打客服电话<span>4006969619</span>】与我们取得联系。<span><br>
        <br>
      </span>本政策中涉及的专用术语和关键词有：<span><br>
        1.“</span>现代支付用户<span>”</span>，指《现代支付用户服务协议》中定义的<span>“</span>现代支付用户<span>”</span>。<span><br>
        2.“</span>现代支付账户<span>”</span>，指《现代支付用户服务协议》中定义的<span>“</span>现代支付账户<span>”</span>，在本政策中，小金管家<span>APP</span>账户属于现代支付账户。<span><br>
        3.“</span>银行卡关联<span>”</span>，指您根据《现代支付用户服务协议》的相关规定注册成为现代支付用户后，在小金管家<span>APP</span>中将您的银行卡卡号与您注册的现代支付账户建立关联关系的行为。<span><br>
        4.“</span>个人信息<span>”</span>，指以电子或者其他方式记录的能够单独或者与其他信息结合识别特定自然人身份或者反映特定自然人活动情况的各种信息。<span><br>
        5.“</span>个人敏感信息<span>”</span>，指一旦泄露、非法提供或滥用可能危害人身和财产安全，极易导致个人名誉、身心健康受到损害或歧视性待遇等的个人信息。<span><br>
        <br>
      </span>一、我们如何收集和使用您的个人信息<span><br>
      </span>在您使用小金管家<span>APP</span>及相关服务时，您理解并同意，我们将可能根据不同场景下的不同目的收集、使用您特定种类的个人信息，这些个人信息将用于您注册账号、银行卡关联、转账等具体功能的实现，这些个人信息对本产品各项功能和服务的实现至关重要，如您不提供相关信息，可能无法注册成为我们的用户或无法享受我们提供的某些服务，或者无法达到相关服务拟达到的效果。此外，为了履行国家法律法规及相关监管的要求，也为向您提供更高质量的服务，我们也将可能收集、使用您的相关个人信息。<span><br>
        <br>
        (</span>一<span>)</span>自行收集的个人信息</p>

      <p><span><br>
      </span>具体而言，小金管家中由我们自行收集和使用的个人信息类型，以及各自的目的与使用方式如下：<span><br>
        1.</span>为履行法律强制性义务和监管要求（包括但不限于反洗钱义务和实名制管理要求），在您注册小金管家<span>APP</span>账户和使用相关服务时，您需完成实名认证过程；为完成实名认证过程，您需提供您的有效身份证件信息、手机号码，以完成验证；如您拒绝提供前述个人信息，则可能无法成功注册小金管家<span>APP</span>账户或使用相关服务；<span><br>
        2.</span>为使您能够使用小金管家<span>APP</span>提供的手机支付服务，实现关联银行卡并使用银行卡进行消费、转账的功能，您需要提供您的姓名、有效身份证件信息、手机号码等个人信息；若您需要开通在线支付服务功能，您还需要提供绑定账户号相关信息；上述信息将用于账号注册和银行卡关联中由发卡银行进行确认的身份验证过程；如您不提供上述个人信息，可能无法使用我们提供的手机支付服务，但不影响您使用我们提供的其他服务；<span><br>
        3.</span>为了准确执行您的支付指令、便于您使用我们提供的支付服务，在您使用转账功能向其他小金管家<span>APP</span>用户转账时，您需要提供收款人注册手机号、收款人姓名、收款人卡号等信息，以完成收款人的验证；在您使用转账功能向他人银行卡转账时，您需要提供收款人卡号、姓名，以完成收款人及其银行卡的验证；如您不提供前述信息，则可能无法使用有关的支付服务，但不影响您使用我们提供的其他服务；<span><br>
        4.</span>为了保障您的账户和资金安全，在您需要找回密码时，您需要提供您的可用于证实您身份的证明资料，用以验证您的身份；<span><br>
        <br>
        (</span>二<span>)</span>从第三方收集的个人信息</p>

      <p><span><br>
      </span>在取得您的同意后，为向您提供特定功能的服务或最优化您的使用体验，我们可能从第三方获取您的个人信息，例如：<span><br>
        1.</span>在还款、开户等需要输入持卡人信息的功能中，为您提供更快捷、迅速的使用体验，我们可能会读取您此前的预留数据，以尽可能减少您的重复输入；<span><br>
        2.</span>为您提供二维码支付等功能时，我们将从合作的收单机构处收集您的交易信息，以完成支付服务的提供过程；<span><br>
        3.</span>从发卡银行或其他第三方合作机构获取您的有关信息（如实名身份信息、积分信息等），以完成实名身份验证、积分验证等服务提供过程。<span><br>
        <br>
        (</span>三<span>)</span>无需同意的特殊情形</p>

      <p><span><br>
      </span>请注意，根据相关法律法规规定，在如下情形中，我们可能会依法收集并使用您的个人信息而无需征得您的同意：<span><br>
        1.</span>与国家安全、国防安全直接相关的；<span><br>
        2.</span>与公共安全、公共卫生、重大公共利益等直接相关的；<span><br>
        3.</span>与犯罪侦查、起诉、审判和执行判决等直接相关的；<span><br>
        4.</span>与行政调查、执法活动等直接相关的；<span><br>
        5.</span>其他法律法规规定的情形。<span><br>
        <br>
      </span>二、我们如何存储和保护您的个人信息</p>

      <p><span><br>
      </span>按照相关法律法规规定，我们将把中华人民共和国境内运营过程中收集和产生的您的个人信息存储在中国境内。<span><br>
      </span>我们仅在为您提供小金管家<span>APP</span>及相关服务之目的所必需的期限内和法律法规及监管规定的时限内留存您的个人信息。<span><br>
      </span>根据我们的备份策略，为确保稳定、持续地向您提供有关服务并落实有关法律法规和监管的要求，您的个人信息将同步存储至小金管家备份数据库；此外，根据我们的大数据平台同步策略，您的个人信息还将实时、准实时或定期批量同步到大数据平台。<span><br>
      </span>如我们停止运营，我们将及时停止收集您个人信息的活动，将停止运营的通知以逐一送达或公告的形式通知您，并对所持有的您的个人信息进行删除或匿名化处理。<span><br>
      </span>我们采取了内部管理制度和技术保障措施等多方面的保护方式以保护您的个人信息，具体而言包括但不限于：<span><br>
        1.</span>内部管理制度上，我们根据信息敏感程度和对象的不同采取了数据分类分级制度，并根据分类分级结果进行使用者权限、使用场景权限、使用授权权限、分级审批机制等多方面的权限限制；<span><br>
        2.</span>技术保障措施上，我们在存储时采取了不可逆的加密存储、隔离存储，在信息展示和下载时采取了脱敏处理，传输时采取了专线传输、加密传输、密钥和数据介质隔离传输等技术措施，以确保您的个人信息安全。<span><br>
      </span>互联网环境并非百分之百安全，我们将尽力确保或担保您发送给我们的任何信息的安全性。如不幸发生个人信息安全事件，我们将按照法律法规的要求，及时向您告知：安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施等。我们将及时将事件相关情况以邮件、信函、电话、推送通知等方式告知您，难以逐一告知个人信息主体时，我们会采取合理、有效的方式发布公告。<span><br>
      </span>同时，我们还将按照监管部门要求，主动上报个人信息安全事件的处置情况。<span><br>
        3.&nbsp;</span>请您务必妥善保管好您的小金管家<span>APP</span>登录名及其他身份要素。您在使用小金管家<span>APP</span>服务时，我们会通过您的登录名及其他身份要素来识别您的身份。一旦您泄漏了前述信息，您可能会蒙受损失，并可能产生对您不利的法律后果。如您发现小金管家<span>APP</span>登录名及<span>/</span>或其他身份要素可能或已经泄露时，请您立即和我们取得联系（拨打客服热线<span>4006969619</span>），以便我们及时采取相应措施以避免或降低相关损失。<span><br>
        <br>
      </span>三、我们如何对外提供您的个人信息<span><br>
        <br>
        (</span>一<span>)</span>与第三方进行业务合作<span><br>
        <br>
      </span>小金管家及相关服务中可能存在涉及第三方的服务，在这些类型的功能和服务的提供过程中，我们可能需要将您的一些个人信息与第三方（包括但不限于我们的关联公司、合作金融机构、服务供应商等其他合作伙伴）共享。在共享过程中，我们会以高度的勤勉义务对待您的个人信息，并且仅在获得您的明确同意之后，或依照法律法规的要求或强制性的政府要求或司法裁定等必须时，与第三方共享您的个人信息。<span><br>
        <br>
      </span>我们仅会出于合法、正当、必要、特定、明确的目的共享您的个人信息，并且只会共享提供该等服务所必要的个人信息。授权第三方无权将共享的个人信息用于任何其他用途，我们将尽商业上的合理努力、采取必要的措施约束第三方，尽可能评估该等第三方收集您个人信息的合法、正当和必要性，具体措施包括但不限于订立相关法律文件、要求第三方承诺遵守相关法律规定并严格保护您的个人信息、对第三方收集和使用个人信息的相关行为进行审计等。您同意我们在以下情形中与第三方共享特定类型的个人信息：<span><br>
        <br>
        1.</span>实现特定业务功能：在收付款等功能使用中，和为您提供相关服务，我们可能会与发卡银行就您的个人信息（例如交易记录、交易明细等信息）进行相应的交互和处理，以实现交易处理的目的；为满足相关业务的法定要求，我们可能将您填写的身份证号码提供给第三方合作机构，以实现实名身份验证的目的。<span><br>
        2.</span>如您选择参与我们与第三方共同开展的抽奖及类似推广活动，为便于第三方能及时向您提供奖品或为您提供服务，我们将可能与其共享在此等活动中收集且完成此等活动所必要的信息，同时我们将根据相关法律法规、国家标准的具体要求，通过活动规则解释页面或其他途径向您明确说明向第三方提供的您的个人信息范围。<span><br>
        <br>
        (</span>二<span>)</span>纠纷处理<span><br>
        <br>
      </span>当您在使用小金管家及相关服务的过程中，如与其他用户、商家等第三方发生纠纷、投诉或被投诉时，为了保护您与其他主体的合法权益，维护良好的交易秩序和社会环境，我们可能会基于有关部门的要求将您的姓名、有效证件号码、联系方式、纠纷内容提供给消费者权益保护部门及监管机关，以便及时处理纠纷，但法律法规明确禁止提供的除外。<span><br>
        <br>
        (</span>三<span>)</span>个人信息的转让<span><br>
        <br>
      </span>原则上，我们不会将您的个人信息转让给任何组织或个人，除非：<span><br>
        1.</span>事先获得您的同意；<span><br>
        2.</span>根据法律法规规定或强制性的行政与司法要求；<span><br>
        3.</span>涉及资产转让、收购、兼并、重组或破产清算时的个人信息转让时，我们会告知您相关情况，并要求接收您个人信息的公司、组织继续受本政策的约束，如发生使用目的、处理方式变化时，该公司、组织将重新取得您的明确同意。<span><br>
        <br>
        (</span>四<span>)</span>获取您的个人信息副本<span><br>
        <br>
      </span>您有权获取您的个人信息副本。如您需要获取我们收集的您的个人信息副本，您可通过【拨打客服电话<span>4006969619</span>】联系我们，在符合相关法律规定且技术可行的前提下，我们将根据您的要求向您提供您的个人信息副本或将您的个人信息副本传输给您指定的第三方。<span><br>
        <br>
        (</span>五<span>)</span>注销您的现代支付账户<span><br>
        <br>
      </span>如您需要注销您的现代支付账户，您可通过【拨打客服热<span>4006969619</span>】联系我们的客服提出注销申请。同样，出于安全性和身份识别等方面的考虑，或根据反洗钱等领域法律法规及监管规定，您需要在通过身份验证之后向我们提出申请方可注销您的现代支付账户。<span><br>
        <br>
        (</span>六<span>)</span>约束自动化决策<span><br>
        <br>
      </span>在某些业务功能中，我们可能仅依据信息系统、算法等在内的非人工自动决策机制做出决定。如果这些决定显著影响您的合法权益，您有权要求我们做出解释，我们也将提供适当的救济方式。如您对此类决策有任何疑问，您可通过【拨打客服热线<span>4006969619</span>】联系我们的客服提交申诉申请，我们在收到您的投诉后将尽快进行处理。<span><br>
        <br>
        (</span>七<span>)</span>对您请求的响应<span><br>
        <br>
      </span>您的任何疑问、建议、意见及投诉，我们将在必要的身份验证通过后进行处理，最长将在不超过三十天或法律法规规定期限内作出答复。然而，按照有关法律法规及国家标准，在以下情形中，我们可能无法响应您的请求：<span><br>
        1.</span>与国家安全、国防安全有关的；<span><br>
        2.</span>与公共安全、公共卫生、重大公共利益等有关的；<span><br>
        3.</span>与犯罪侦查、起诉、审判和执行判决等有关的；<span><br>
        4.</span>与行政调查、执法活动等直接相关的；<span><br>
        5.</span>其他法律法规规定的情形。<span><br>
        <br>
      </span>五、<span>Cookie</span>和同类技术的使用<span><br>
        <br>
      </span>为确保您获得更为流畅、轻松的使用体验，在您使用小金管家<span>APP</span>及相关服务时，我们可能会通过小型数据文件识别您的身份，以帮助您减少信息录入的次数和频率，或协助判断您账户的安全状况。<span>Cookie&nbsp;</span>通常包含标识符、站点名称以及一些号码和字符。借助于<span>&nbsp;Cookie</span>，网站能够存储您的偏好或购物篮内的商品等数据。<span><br>
        <br>
      </span>我们不会将<span>&nbsp;Cookie&nbsp;</span>用于本政策所述目的之外的任何用途。您可根据自己的偏好管理或删除<span>&nbsp;Cookie</span>。您可随时清除设备上保存的所有<span>Cookie</span>，但如果您选择清除，则需要在每一次使用设备访问相关网站、浏览查看商品等过程中重新进行用户设置。<span><br>
        <br>
      </span>六、未成年人使用条款<span><br>
        <br>
      </span>请注意，小金管家<span>APP</span>及其提供的服务主要面向成人和企业单位，我们不会以任何方式主动收集未成年人相关的个人信息，如无父母或监护人的同意，未成年人亦不得创建自己的用户账户。在接受本政策并申请注册时，请确认您已符合条件，一旦您选择接受本政策并申请注册，您将被视为已确认不属于未成年人。如果我们发现在未事先获得可证实的年龄确认等情况下收集了未成年人的个人信息，则会设法尽快删除相关数据。<span><br>
        <br>
      </span>七、第三方提供服务的免责声明<span><br>
        <br>
      </span>小金管家<span>APP</span>及相关服务中可能包括或链接至第三方提供的信息或其他服务（包括网站）。该第三方服务可能由相关的第三方运营。您使用该等第三方服务（包括您向该等第三方提供的任何个人信息），须受该第三方的服务条款及隐私政策（而非本政策）约束，您需要仔细阅读其条款并自行决定是否接受。请您妥善保护自己的个人信息，仅在必要的情况下向他人提供。本政策仅适用于我们所收集、保存、使用、共享、披露信息，并不适用于任何第三方提供的服务或第三方的信息使用规则，我们对任何第三方使用由您提供的信息不承担任何责任。<span><br>
        <br>
      </span>八、本政策的适用与更新<span><br>
        <br>
      </span>除明确说明应适用其他特别制定并发布的单独隐私政策或条款的服务以外，本政策适用于您使用的小金管家<span>APP</span>上我们提供的所有相关服务。<span><br>
        <br>
      </span>根据法律法规要求和商业实践的具体情况，我们将不时更新本政策，但未经您明确同意，我们不会削减您依据当前生效的本政策所应享受的权利。当本政策发生重大变化时，我们将采取弹窗提醒、消息推送等方式及时通知您，构成重大变化的情况包括但不限于：<span><br>
        1.</span>我们提供的服务范围、模式等发生重大变化，如收集、使用个人信息的目的、类型等发生改变；<span><br>
        2.</span>我们的经营主体发生重大变化，如业务调整、兼并收购重组等引起所有权变更；<span><br>
        3.</span>您访问和管理自己个人信息的渠道发生重大变化；<span><br>
        4.</span>我们存储、共享和披露个人信息的方式、对象等发生变化；<span><br>
        5.</span>个人信息风险评估报告显示出现重大风险，需要进行业务实践或内部制度的重大调整；<span><br>
        6.</span>负责个人信息保护的部门及其联系方式发生变化；<span><br>
        7.</span>其他可能对您的个人信息权益产生重大影响的变化。<span><br>

      </span></p>
      <div style="text-align:center;">
        <el-button type="primary" @click="closeAgree">同意</el-button>
        <el-button type="info" @click="closeNoAgree">不同意</el-button>
      </div> -->

     </el-dialog>
  </div>
</template>
<script>
export default {
  name: 'AgreeMent',
  data() {
    return {
      dialogVisible: false,
      flag: null
    }
  },
  methods: {
    // 新建弹窗
    open: function() {
      this.dialogVisible = true
      // console.log('展开')
    },
    closeAgree() {
      this.dialogVisible = false
      this.flag = 1
      this.$emit('transfer', this.flag)// 将值绑定到transfer上传递过去
    },
    closeNoAgree() {
      this.dialogVisible = false
      this.flag = 2
      this.$emit('transfer', this.flag)// 将值绑定到transfer上传递过去
    }
  }
}
</script>
<style></style>
